import script from "./ReportDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportDetailDrawer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__